import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  {
    '@global': {
      html: {
        fontFamily: 'var(--fonts-gilroy)',
      },
    },
  },
  { name: 'app' },
);

export default useStyles;
